// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import outlineImage from "@iconify/icons-ic/outline-image";
import RefreshIcon from "@mui/icons-material/Refresh";
import ClearIcon from "@mui/icons-material/Clear";
import { Portal } from "@mui/base";
import CachedIcon from "@mui/icons-material/Cached";
import { v4 as uuidv4 } from "uuid";
import {
  Card,
  Table,
  Stack,
  Autocomplete,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Breadcrumbs,
  Link,
  FormControlLabel,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  createFilterOptions,
  InputAdornment,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi, BaseURL } from "../statics.js";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const defaultFilterOptions = createFilterOptions();

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

// const TABLE_HEAD = [
//   { id: "title", label: "Title", alignRight: false },
//   { id: "dimensionType", label: "Dimension Type", alignRight: false },
//   { id: "obsoletedPrice", label: "Obsoleted Price With", alignRight: false },
//   { id: "isLinkTo", label: "Is Link To", alignRight: false },
//   { id: "priceAmount", label: "Price", alignRight: false },
//   { id: "items", label: "Items", alignRight: false },
//   { id: "" },
// ];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function StepItems() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [stepTitle, setStepTitle] = useState("");
  const [stepTitleErrorText, setStepTitleErrorText] = useState("");
  const [stepDes, setStepDes] = useState("");
  const [stepDesErrorText, setStepDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [stepsList, setStepsList] = useState([]);
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addStepLoading, setAddStepLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);

  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentStepItem, setCurrentStepItem] = useState({
    id: "",
    title: "",
  });
  const [priceValue, setPriceValue] = useState("");
  const [priceValueErrorText, setPriceValueErrorText] = useState("");
  const [parnetNameList, setParnetNameList] = useState([]);
  const [isLinkToDetailItems, setIsLinkToDetailItems] = useState("none");
  const [detailItemsList, setDetailItemsList] = useState([]);
  const [selectedDetailItems, setSelectedDetailItems] = useState([]);
  const [detailItemValue, setDetailItemValue] = useState(null);
  const [detailItemValueErrorText, setDetailItemValueErrorText] = useState("");

  const [detailList, setDetailList] = useState([]);
  const [detailValue, setDetailValue] = useState("");
  const [detailValueErrorText, setDetailValueErrorText] = useState("");
  const [detailItemsText, setDetailItemsText] = useState("");
  const [priceType, setPriceType] = useState("");
  const [TABLE_HEAD, setTABLE_HEAD] = useState([]);
  const [picDialogOpen, setPicDialogOpen] = useState(false);
  const [currentItemsPic, setCurrentItemsPic] = useState(null);
  const [uploadList, setUploadList] = useState([]);
  const [priorityValue, setPriorityValue] = useState("");

  const [copyToDialog, setCopyToDialog] = useState(false);
  const [copyToPath, setCopyToPath] = useState([]);
  const [allSteps, setAllSteps] = useState([]);

  const navigate = useNavigate();

  //   let { stepId } = useParams();
  let params = useParams();

  // const stepTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const formatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
    };
    setDataLoading(true);
    CallApi("getConfig", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          // console.log("getConfig: ", result.result);
          setConfig(result.result);
          // setPriceTypeList(result.result.priceTypes);
          setDimensionTypeList(result.result.dimensionTypes);

          getAllSteps();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const getAllSteps = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 100000,
    };
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setCopyToPath([{ id: uuidv4(), list: result.result, value: "" }]);
          setStepsList(result.result);
          setAllSteps(result.result);
          getAllDetails();
        }
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const getAllDetails = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 100000,
    };
    CallApi("getAllDetails", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setDetailList(result.result);
          // findItemswithPath();
          findAllDetailItems("");
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const findAllDetailItems = (searchKey) => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      searchKey: searchKey,
    };
    CallApi("findAllDetailItems", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          let temp = [];
          result.result.forEach((element) => {
            element.detailItems.forEach((element1) => {
              temp.push(element1);
            });
          });
          setDetailItemsList(temp);
          findItemswithPath();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const findItemswithPath = () => {
    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: parents,
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setParnetNameList(result.parnetNameList);
          setPriceType(result.parnetNameList[0].priceType);
          setTABLE_HEAD(
            result.parnetNameList[0].priceType !== "none"
              ? [
                  { id: "title", label: "Title", alignRight: false },
                  {
                    id: "description",
                    label: "Description",
                    alignRight: false,
                  },
                  {
                    id: "dimensionType",
                    label: "Dimension Type",
                    alignRight: false,
                  },
                  {
                    id: "obsoletedPrice",
                    label: "Obsoleted Price With",
                    alignRight: false,
                  },
                  { id: "isLinkTo", label: "Is Link To", alignRight: false },
                  {
                    id: "priceAmount",
                    label:
                      result.parnetNameList[0].priceType === "perm"
                        ? "IRR/m"
                        : result.parnetNameList[0].priceType === "persm"
                        ? "IRR/m\u00B2"
                        : result.parnetNameList[0].priceType === "coofsm"
                        ? "IRR*m\u00B2"
                        : "IRR",
                    alignRight: false,
                  },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
              : [
                  { id: "title", label: "Title", alignRight: false },
                  {
                    id: "description",
                    label: "Description",
                    alignRight: false,
                  },
                  {
                    id: "dimensionType",
                    label: "Dimension Type",
                    alignRight: false,
                  },
                  {
                    id: "obsoletedPrice",
                    label: "Obsoleted Price With",
                    alignRight: false,
                  },
                  { id: "isLinkTo", label: "Is Link To", alignRight: false },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
          );
          setTotalItems(result.paginateInfo.totalItems);
        }

        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) findItemswithPath();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) stepTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setStepTitle("");
    setStepDes("");
    setPriceValue("");
    setStepTitleErrorText("");
    setStepDesErrorText("");
    setPriceValueErrorText("");
    setDimensionTypeValue([dimensionTypeList[0].id]);
    setMinHeight("");
    setMaxHeight("");
    setMinWidth("");
    setMaxWidth("");
    setPriorityValue("");
    setObsoletedValue("");
    setIsLinkToDetailItems("none");
    setSelectedDetailItems([]);
    setDetailItemValue(null);
    setDetailItemValueErrorText("");
    setDetailItemsText("");
    setDetailValue("");
    setDimensionTypeValueErrorText("");
    setMinHeightErrorText("");
    setMinWidthErrorText("");
    setMaxHeightErrorText("");
    setMaxWidthErrorText("");
    setObsoletedValueErrorText("");
    setUploadList([]);
    setAddDialogOpen(true);
  };

  const addStepItem = () => {
    if (!stepTitle) {
      setStepTitleErrorText("Step title cannot be empty");
      return;
    } else {
      setStepTitleErrorText("");
    }

    // if (!priceValue) {
    //   setPriceValueErrorText("Price cannot be empty");
    //   return;
    // } else {
    //   setPriceValueErrorText("");
    // }
    if (!dimensionTypeValue) {
      setDimensionTypeValueErrorText("Dimension type cannot be empty");
      return;
    } else {
      setDimensionTypeValueErrorText("");
    }
    if (dimensionTypeValue && dimensionTypeValue[0] !== "none") {
      if (!minHeight) {
        setMinHeightErrorText("Min height cannot be empty");
        return;
      } else {
        setMinHeightErrorText("");
      }

      if (!maxHeight) {
        setMaxHeightErrorText("Max height cannot be empty");
        return;
      } else {
        setMaxHeightErrorText("");
      }

      if (!minWidth) {
        setMinWidthErrorText("Min width cannot be empty");
        return;
      } else {
        setMinWidthErrorText("");
      }

      if (!maxWidth) {
        setMaxWidthErrorText("Max width cannot be empty");
        return;
      } else {
        setMaxWidthErrorText("");
      }
    }

    let di = [];
    if (isLinkToDetailItems === "detailItem") {
      if (selectedDetailItems.length < 1) {
        setDetailItemValueErrorText("Detail Item cannot be empty");
        return;
      } else {
        selectedDetailItems.forEach((element) => {
          di.push(element._id);
        });
        setDetailItemValueErrorText("");
      }
    } else if (isLinkToDetailItems === "detail") {
      if (detailValue.length < 1) {
        setDetailValueErrorText("Detail cannot be empty");
        return;
      } else {
        setDetailValueErrorText("");
      }
    }
    console.log(uploadList);
    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: stepTitle ? stepTitle : "",
      descr: stepDes ? stepDes : "",
      priceAmount: priceValue ? priceValue : 0,
      pic: uploadList.length > 0 ? uploadList[0].fileName : "",
      stepId: parents[0],
      parentList: parents,
      isLinkToDetailItem: isLinkToDetailItems === "detailItem" ? true : false,
      detailItemList: isLinkToDetailItems === "detailItem" ? di : [],
      isLinkToDetail: isLinkToDetailItems === "detail" ? true : false,
      detailId: isLinkToDetailItems === "detail" ? detailValue[0] : "",
      dimensionType: dimensionTypeValue ? dimensionTypeValue[0] : null,
      dimensionAttr:
        dimensionTypeValue && dimensionTypeValue[0] !== "none"
          ? {
              height: { min: minHeight, max: maxHeight },
              width: { min: minWidth, max: maxWidth },
            }
          : null,
      obsoletedPrice: obsoletedValue ? obsoletedValue[0] : "",
      priority: priorityValue,
    };
    let apiname = "addItemToStep";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        itemId: currentStepItem._id,
        title: stepTitle ? stepTitle : "",
        descr: stepDes ? stepDes : "",
        priceAmount: priceValue ? priceValue : 0,
        pic: uploadList.length > 0 ? uploadList[0].fileName : "",
        isLinkToDetailItem: isLinkToDetailItems === "detailItem" ? true : false,
        detailItemList: isLinkToDetailItems === "detailItem" ? di : [],
        isLinkToDetail: isLinkToDetailItems === "detail" ? true : false,
        detailId: isLinkToDetailItems === "detail" ? detailValue[0] : "",
        dimensionType: dimensionTypeValue ? dimensionTypeValue[0] : null,
        dimensionAttr:
          dimensionTypeValue && dimensionTypeValue[0] !== "none"
            ? {
                height: { min: minHeight, max: maxHeight },
                width: { min: minWidth, max: maxWidth },
              }
            : null,
        obsoletedPrice: obsoletedValue ? obsoletedValue[0] : "",
        priority: priorityValue,
      };
      apiname = "updateStepItems";
    }

    console.log(data);
    // return;
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            findItemswithPath();
            setSnackType("success");

            if (apiname === "addItemToStep")
              setSnackbarMessage(
                "'" + stepTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + stepTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentStepItem(item);
      setDialogMode("update");
      setStepTitle(item.title);
      setStepDes(item.descr ? item.descr : "");
      setPriceValue(item.priceAmount ? item.priceAmount : "");
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      setIsLinkToDetailItems(
        item.isLinkToDetailItem
          ? "detailItem"
          : item.isLinkToDetail
          ? "detail"
          : "none"
      );
      let temp = [];
      item.detailItemList.forEach((element) => {
        detailItemsList.forEach((element1) => {
          if (element === element1._id) {
            let el = JSON.parse(JSON.stringify(element1));
            el.uniqId = uuidv4();
            temp.push(el);
          }
        });
      });
      setSelectedDetailItems(temp);
      setDetailValue([item.detailId]);
      setDimensionTypeValue(
        item.dimensionType ? [item.dimensionType] : [dimensionTypeList[0].id]
      );
      if (item.dimensionAttr) {
        setMinHeight(item.dimensionAttr.height.min);
        setMaxHeight(item.dimensionAttr.height.max);
        setMinWidth(item.dimensionAttr.width.min);
        setMaxWidth(item.dimensionAttr.width.max);
      } else {
        setMinHeight("");
        setMaxHeight("");
        setMinWidth("");
        setMaxWidth("");
      }
      setObsoletedValue(
        item.obsoletedPrice &&
          stepsList.filter((itm) => itm._id === item.obsoletedPrice).length > 0
          ? [item.obsoletedPrice]
          : ""
      );
      setUploadList(
        item.pic
          ? [
              {
                file: { name: item.pic.replace("public/", "") },
                fileName: item.pic,
                status: "ok",
              },
            ]
          : []
      );
      setPriceValueErrorText("");
      setStepTitleErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentStepItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const onCopyToItem = (item) => {
    if (!buttonDisabled) {
      setCopyToPath([{ id: uuidv4(), list: allSteps, value: "" }]);
      setCurrentStepItem(item);
      setCopyToDialog(true);
    }
  };

  const handleChangeDimensionType = (event) => {
    const {
      target: { value },
    } = event;
    setDimensionTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeObsoleted = (event) => {
    const {
      target: { value },
    } = event;
    setObsoletedValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      itemId: currentStepItem._id,
    };

    // console.log(data);

    setButtonDisabled(true);
    CallApi("removeStepItems", "post", data)
      .then((result) => {
        try {
          // console.log(result);
          if (result.status === 200) {
            findItemswithPath();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const getBreadcrumbsLink = (id) => {
    let l = "";
    let end = false;
    parnetNameList.forEach((element) => {
      if (!end) l += "/" + element._id;
      if (id === element._id) end = true;
    });

    return l.toString();
  };

  const handleChangeDetailItems = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedDetailItems(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangeDetail = (event) => {
    const {
      target: { value },
    } = event;
    setDetailValue(typeof value === "string" ? value.split(",") : value);
  };

  const onSelectFileComplete = (event) => {
    let files = [];

    for (let i = 0; i < event.target.files.length; i++) {
      // console.log(event.target.files[i]);
      if (
        !event.target.files[i] ||
        (event.target.files[i].type !== "image/jpg" &&
          event.target.files[i].type !== "image/webp" &&
          event.target.files[i].type !== "image/png" &&
          event.target.files[i].type !== "image/jpeg")
      ) {
        setSnackType("error");
        setSnackbarMessage("some files not valid for uploading");
        setSnackbarOpen(true);
        return;
      } else {
        files.push({ file: event.target.files[i], status: "loading" });
      }
    }

    setUploadList(files);
    document.getElementById("selectPicDialog").value = "";
  };

  useEffect(() => {
    if (uploadList.length > 0) {
      let found = false;
      uploadList.forEach((element) => {
        if (!found && element.status === "loading") {
          found = true;
          uploadFile(element.file);
        }
      });
    }
  }, [uploadList]);

  const uploadFile = (file) => {
    const data = new FormData();
    data.append("picture", file);
    data.append("username", getCookie("username"));
    data.append("token", getCookie("token"));

    console.log(file);
    CallApi("uploadPicture", "post", data, true)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "ok", fileName: result.fileName };
              }
              return obj;
            });

            setUploadList(newState);
          } else {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "failed" };
              }
              return obj;
            });

            setUploadList(newState);
          }
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        const newState = uploadList.map((obj) => {
          if (obj.file === file) {
            return { ...obj, status: "failed" };
          }
          return obj;
        });

        setUploadList(newState);
      });
  };

  const onResultClick = (item) => {
    setCurrentItemsPic(item.pic);
    setPicDialogOpen(true);
  };

  const loadSubCat = () => {
    findItemswithPath1();
  };

  const findItemswithPath1 = () => {
    let parents = [];

    copyToPath.forEach((element) => {
      parents.push(element.value);
    });

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: parents,
      page: 0,
      count: 100000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let path = JSON.parse(JSON.stringify(copyToPath));
            path.push({ id: uuidv4(), list: result.result, value: "" });
            setCopyToPath(path);
          } else {
            setSnackType("error");
            setSnackbarMessage("there is no step-item in this step");
            setSnackbarOpen(true);
          }
        }

        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
        setButtonDisabled(false);
      }
    });
  };

  const confirmCopy = () => {
    let i = 0;
    let index = -1;
    let destinationSIPath = [];
    console.log(copyToPath);

    copyToPath.forEach((element) => {
      if (!element.value && index === -1) index = i;
      destinationSIPath.push(element.value);
      i++;
    });

    if (index > -1) {
      if (index === 0) {
        setSnackType("error");
        setSnackbarMessage("please select destination step");
        setSnackbarOpen(true);
      } else {
        setSnackType("error");
        setSnackbarMessage("please select step item " + index);
        setSnackbarOpen(true);
      }

      return;
    }

    let parents = params["*"].split("/");
    parents.push(currentStepItem._id);
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      originStepId: parents[0],
      destinationStepId: copyToPath[0].value,
      originSIPath: "," + parents.toString() + ",",
      destinationSIPath: "," + destinationSIPath.toString() + ",",
    };

    console.log(data);
    // return;
    setButtonDisabled(true);
    CallApi("copySIs", "post", data)
      .then((result) => {
        setButtonDisabled(false);
        try {
          console.log(result);
          setSnackType("success");
          setSnackbarMessage("step items successfully copied");
          setSnackbarOpen(true);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Step Items | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          ></Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            {/* <Typography variant="h4" gutterBottom>
              Step Item of
            </Typography> */}
            <Breadcrumbs aria-label="breadcrumb" mb={2}>
              <Link key={-1} underline="hover" color="inherit" href={"/steps"}>
                Steps
              </Link>
              {parnetNameList.map((item, i) => {
                if (i === parnetNameList.length - 1) {
                  return (
                    <Typography key={i} color="text.primary">
                      {item.title}
                    </Typography>
                  );
                } else
                  return (
                    <Link
                      key={i}
                      underline="hover"
                      color="inherit"
                      href={"/steps" + getBreadcrumbsLink(item._id)}
                    >
                      {item.title}
                    </Link>
                  );
              })}
            </Breadcrumbs>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Step Item
            </Button>
          </Stack>

          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        // console.log(row);
                        const {
                          _id,
                          title,
                          descr,
                          priceAmount,
                          dimensionType,
                          obsoletedPrice,
                          isLinkToDetail,
                          isLinkToDetailItem,
                          path,
                          pic,
                        } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            <TableCell>
                              {dimensionType
                                ? dimensionTypeList.filter(
                                    (item) => item.id === dimensionType
                                  )[0].title
                                : "-"}
                            </TableCell>
                            <TableCell>
                              {obsoletedPrice &&
                              stepsList.filter(
                                (item) => item._id === obsoletedPrice
                              ).length > 0
                                ? stepsList.filter(
                                    (item) => item._id === obsoletedPrice
                                  )[0].title
                                : "-"}
                            </TableCell>
                            <TableCell>
                              {isLinkToDetail
                                ? "Detail"
                                : isLinkToDetailItem
                                ? "Detail Items"
                                : "None"}
                            </TableCell>
                            {priceType !== "none" && (
                              <TableCell>
                                {priceAmount ? formatter(priceAmount) : "-"}
                              </TableCell>
                            )}
                            <TableCell align="left">
                              {pic && (
                                <IconButton
                                  aria-label="result"
                                  onClick={() => {
                                    onResultClick(row);
                                  }}
                                >
                                  <Icon icon={outlineImage} fontSize={22} />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="left">
                              <Link
                                href={
                                  "/steps" + path.replaceAll(",", "/") + _id
                                }
                              >
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                                onCopyTo={() => onCopyToItem(row)}
                                hasCopyTo
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Step</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentStepItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Step Item" : "Edit Step Item"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={stepTitle}
            // inputRef={stepTitleTextField}
            onChange={(e) => setStepTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addStepLoading}
            helperText={stepTitleErrorText}
            error={stepTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={stepDes}
            onChange={(e) => setStepDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={stepDesErrorText}
            error={stepDesErrorText ? true : false}
          />

          {priceType && priceType !== "none" && (
            <TextField
              fullWidth
              sx={{ mb: 2 }}
              autoFocus
              type="text"
              label={
                priceType === "fixed" ||
                priceType === "perm" ||
                priceType === "persm"
                  ? "IRR"
                  : "Coefficient of Square of m"
              }
              value={priceValue}
              onChange={(e) => setPriceValue(e.target.value)}
              disabled={buttonDisabled}
              helperText={priceValueErrorText}
              error={priceValueErrorText ? true : false}
              name="priceTextField"
              InputProps={
                priceType === "fixed"
                  ? { inputComponent: NumericFormatCustom }
                  : {
                      inputComponent: NumericFormatCustom,
                      endAdornment: (
                        <InputAdornment position="end">
                          {priceType === "perm"
                            ? "/m"
                            : priceType === "persm"
                            ? "/m\u00B2"
                            : "*m\u00B2"}
                        </InputAdornment>
                      ),
                    }
              }
            />
          )}

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={dimensionTypeValueErrorText ? true : false}
          >
            <InputLabel>Dimension Type</InputLabel>
            <Select
              value={dimensionTypeValue ? dimensionTypeValue : ""}
              onChange={handleChangeDimensionType}
              input={<OutlinedInput label="Dimension Type" />}
              MenuProps={MenuProps}
            >
              {dimensionTypeList.map((pt) => (
                <MenuItem key={pt.id} value={pt.id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{dimensionTypeValueErrorText}</FormHelperText>
          </FormControl>

          {dimensionTypeValue[0] === "limit" && (
            <Stack direction="row" spacing={1} mb={2}>
              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Min Height(mm)"
                value={minHeight}
                onChange={(e) => setMinHeight(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={minHeightErrorText}
                error={minHeightErrorText ? true : false}
              />

              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Max Height(mm)"
                value={maxHeight}
                onChange={(e) => setMaxHeight(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={maxHeightErrorText}
                error={maxHeightErrorText ? true : false}
              />
            </Stack>
          )}

          {dimensionTypeValue[0] === "limit" && (
            <Stack direction="row" spacing={1} mb={2}>
              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Min Width(mm)"
                value={minWidth}
                onChange={(e) => setMinWidth(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={minWidthErrorText}
                error={minWidthErrorText ? true : false}
              />

              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Max Width(mm)"
                value={maxWidth}
                onChange={(e) => setMaxWidth(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={maxWidthErrorText}
                error={maxWidthErrorText ? true : false}
              />
            </Stack>
          )}

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
          />

          {stepsList.length > 0 && (
            <FormControl
              sx={{ mb: 2 }}
              fullWidth
              disabled={buttonDisabled}
              error={obsoletedValueErrorText ? true : false}
            >
              <InputLabel>Obsoleted Price With</InputLabel>
              <Select
                IconComponent={() =>
                  obsoletedValue && obsoletedValue.length > 0 ? (
                    <div
                      style={{
                        marginRight: "10px",
                        padding: "4px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => setObsoletedValue("")}
                    >
                      <ClearIcon style={{ fontSize: "20px" }} />
                    </div>
                  ) : null
                }
                value={obsoletedValue ? obsoletedValue : ""}
                onChange={handleChangeObsoleted}
                input={<OutlinedInput label="Obsoleted Price With" />}
                MenuProps={MenuProps}
              >
                {stepsList.map((pt) => (
                  <MenuItem key={pt._id} value={pt._id}>
                    {pt.title}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{obsoletedValueErrorText}</FormHelperText>
            </FormControl>
          )}

          <ToggleButtonGroup
            fullWidth
            color="primary"
            value={isLinkToDetailItems}
            exclusive
            onChange={(e, n) => {
              setDetailValue("");
              setSelectedDetailItems([]);
              setIsLinkToDetailItems(n);
            }}
            sx={{ width: "100%", whiteSpace: "nowrap", mb: 2 }}
          >
            <ToggleButton value="none">None</ToggleButton>
            <ToggleButton value="detail">Link To Detail</ToggleButton>
            <ToggleButton value="detailItem">Link To Detail Items</ToggleButton>
          </ToggleButtonGroup>

          {isLinkToDetailItems === "detailItem" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                // alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <FormControl fullWidth disabled={buttonDisabled}>
                  <Autocomplete
                    // multiple
                    // size="small"
                    options={detailItemsList}
                    getOptionLabel={(option) => option.title}
                    // filterSelectedOptions
                    // filterOptions={(options, state) => {
                    //   if (detailItemsText && detailItemsText.length > 0)
                    //     return defaultFilterOptions(options, state).slice(0, 5);
                    //   else return [];
                    // }}
                    onChange={(e, a) => {
                      setDetailItemsText("");
                      console.log(a);
                      if (a) setDetailItemValue(a);
                    }}
                    onInputChange={(e, value, reason) => {
                      if (reason === "clear") setDetailItemValue(null);
                    }}
                    noOptionsText={
                      detailItemsText
                        ? "No options"
                        : "Write a detail item title"
                    }
                    value={detailItemValue}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Detail Item"
                        placeholder="Search Detail Items"
                        onChange={(e) => {
                          setDetailItemsText(e.target.value);
                        }}
                        error={detailItemValueErrorText ? true : false}
                        value={detailItemsText}
                      />
                    )}
                  />
                  {/* <Autocomplete
                multiple
                options={detailItemsList}
                getOptionLabel={(option) => option.title}
                filterSelectedOptions
                filterOptions={(options, state) => {
                  if (detailItemsText && detailItemsText.length > 0)
                    return defaultFilterOptions(options, state).slice(0, 5);
                  else return [];
                }}
                onChange={(e, a) => {
                  setDetailItemsText("");
                  setSelectedDetailItemsValue(a);
                }}
                noOptionsText={
                  detailItemsText ? "No options" : "Write a detail item title"
                }
                value={selectedDetailItemsValue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Detail Items"
                    placeholder="Detail Items"
                    onChange={(e) => {
                      setDetailItemsText(e.target.value);
                    }}
                    error={selectedDetailItemsValueErrorText ? true : false}
                    value={detailItemsText}
                  />
                )}
              /> */}
                  <FormHelperText>{detailItemValueErrorText}</FormHelperText>
                </FormControl>
                <div>
                  <Button
                    size="large"
                    // fullWidth
                    // sx={{ mt: 2, mb: 1 }}
                    onClick={() => {
                      let item = JSON.parse(JSON.stringify(detailItemValue));
                      item.uniqId = uuidv4();
                      let selectedItm = JSON.parse(
                        JSON.stringify(selectedDetailItems)
                      );
                      selectedItm.push(item);
                      setSelectedDetailItems(selectedItm);
                      console.log(selectedItm);

                      setDetailItemValue(null);
                    }}
                    variant="outlined"
                    startIcon={<AddIcon />}
                    component="label"
                    disabled={!detailItemValue || buttonDisabled}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                {selectedDetailItems.map((item) => {
                  return (
                    <Chip
                      key={item.uniqId}
                      label={item.title}
                      onDelete={() => {
                        setSelectedDetailItems(
                          selectedDetailItems.filter(
                            (itm) => itm.uniqId !== item.uniqId
                          )
                        );
                      }}
                    />
                  );
                })}
              </div>
              {selectedDetailItems.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    minHeight: "1px",
                    backgroundColor: "var(--black2)",
                  }}
                />
              )}
            </div>
          )}

          {isLinkToDetailItems === "detail" && (
            <FormControl
              sx={{ mb: 2 }}
              fullWidth
              error={detailValueErrorText ? true : false}
              disabled={buttonDisabled}
            >
              <InputLabel>Detail</InputLabel>
              <Select
                value={detailValue ? detailValue : ""}
                onChange={handleChangeDetail}
                // multiple={dialogMode !== "update"}
                input={<OutlinedInput label="Detail" />}
                MenuProps={MenuProps}
              >
                {detailList.map((pt) => (
                  <MenuItem key={pt._id} value={pt._id}>
                    {pt.title}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{detailValueErrorText}</FormHelperText>
            </FormControl>
          )}

          <Button
            fullWidth
            sx={{ mt: 2, mb: 1 }}
            // onClick={() => setDialogOpen(false)}
            variant="outlined"
            disabled={buttonDisabled}
            startIcon={<CloudUploadIcon />}
            component="label"
          >
            Upload Picture
            <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            />
          </Button>

          <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {uploadList.map((item, i) => {
              return (
                <Chip
                  disabled={buttonDisabled}
                  key={i}
                  sx={{ mb: 0.5, mr: 0.5 }}
                  icon={
                    item.status === "ok" ? (
                      <CheckIcon />
                    ) : item.status === "failed" ? (
                      <Tooltip title="Retry">
                        <IconButton
                          aria-label="retry"
                          size="small"
                          onClick={() => {
                            const newState = uploadList.map((obj) => {
                              if (obj.file === item.file) {
                                return { ...obj, status: "loading" };
                              }
                              return obj;
                            });

                            setUploadList(newState);
                          }}
                        >
                          <RefreshIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <CircularProgress color="secondary" size={20} />
                    )
                  }
                  label={item.file.name}
                  variant="outlined"
                  color={
                    item.status === "ok"
                      ? "primary"
                      : item.status === "ok"
                      ? "error"
                      : "secondary"
                  }
                  onDelete={
                    item.status === "ok"
                      ? () => {
                          setUploadList((chips) =>
                            chips.filter((chip) => chip.file !== item.file)
                          );
                        }
                      : undefined
                  }
                />
              );
            })}
          </Box>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addStepItem}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={picDialogOpen}
        TransitionComponent={Transition}
        onClose={() => {
          setPicDialogOpen(false);
        }}
      >
        <DialogContent>
          <img alt="" src={BaseURL + currentItemsPic} />
        </DialogContent>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={copyToDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setCopyToDialog(false);
        }}
      >
        <DialogTitle>Specify the destination path</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {copyToPath.map((item, i) => {
            return (
              <FormControl
                key={item.id}
                sx={{ mb: 2, mt: 1 }}
                fullWidth
                disabled={buttonDisabled}
                // error={productValueErrorText ? true : false}
              >
                <InputLabel>{i < 1 ? "Step" : "Step Item " + i}</InputLabel>
                <Select
                  value={item.value ? item.value : ""}
                  onChange={(e) => {
                    let path = JSON.parse(JSON.stringify(copyToPath));
                    let index = 0;
                    let counter = 0;
                    path.forEach((element) => {
                      if (element.id === item.id) {
                        element.value = e.target.value;
                        index = counter;
                      }
                      counter++;
                    });

                    if (path.length - 1 > index) path.splice(index + 1);

                    setCopyToPath(path);
                  }}
                  input={
                    <OutlinedInput
                      label={i < 1 ? "Product" : "Product Step " + i}
                    />
                  }
                  MenuProps={MenuProps}
                >
                  {item.list.map((pt) => (
                    <MenuItem key={pt._id} value={pt._id}>
                      {pt.title}
                    </MenuItem>
                  ))}
                </Select>
                {/* <FormHelperText>{productValueErrorText}</FormHelperText> */}
              </FormControl>
            );
          })}
          {copyToPath[copyToPath.length - 1]?.value && (
            <Button
              fullWidth
              sx={{ mb: 1 }}
              onClick={loadSubCat}
              variant="outlined"
              disabled={buttonDisabled}
              startIcon={<CachedIcon />}
              component="label"
            >
              Load Step Items
            </Button>
          )}

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={confirmCopy}
            variant="contained"
            disabled={buttonDisabled}
          >
            Copy
          </Button>
          <Button
            onClick={() => setCopyToDialog(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
